import { Link } from "react-router-dom";

import Text from "../../components/Text";
import everyoneImage from "../../assets/images/everyone_app.png";
import prosImage from "../../assets/images/pros.png";
import HeaderIntro from "../../layouts/HeaderIntro";
import styled from "styled-components";
import Footer from "../../layouts/Footer";

const Intro = () => {
  return (
    <>
      <HeaderIntro />
      <main className=" lg:px-8 flex xs:flex-col lg:flex-row max-w-[1400px] m-auto lg:w-[95%] font-normal text-[#686868]">
        <div className="xs:block lg:hidden w-full h-24 bg-[#F5E8D5]"></div>
        <section className="everyone-box overflow-hidden lg:mr-4 lg:w-1/2 bg-[#F5E8D5] relative">
          <div className="wrapper flex flex-row xs:h-[420px] lg:h-[471px]">
            <div className="text-wrapper xs:w-8/12 md:w-6/12  xs:px-5 sm:px-12 flex-auto flex flex-col justify-center">
              <div className="text">
                <div className="heading mb-4  font-normal text-[14px] text-black">
                  <Text classes="uppercase">for everyone</Text>
                </div>
                <div className="desc xs:text-2xl md:text-3xl mb-4 ">
                  <Text>
                    Healthy snacks, consultations, and diet services in one
                    place
                  </Text>
                </div>
                <div className="button flex">
                  <HoveredLink
                    className="shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded uppercase text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] text-sm"
                    to={"/everyone"}
                  >
                    Change your life
                  </HoveredLink>
                </div>
              </div>
            </div>
            <div className="img xs:w-4/12 md:w-6/12">
              <img
                src={everyoneImage}
                alt=""
                className="xs:h-[95%] lg:h-4/6 absolute top-1/2 -translate-y-1/2 xs:right-auto sm:right-0 md:-right-6"
              />
            </div>
          </div>
        </section>
        <section className="professional-box relative overflow-hidden lg:ml-4 lg:w-1/2">
          <div className="wrapper flex flex-row bg-white xs:h-[420px] lg:h-[471px]">
            <div className="text-wrapper xs:w-8/12 md:w-6/12  xs:px-5 sm:px-12 flex-auto flex flex-col justify-center">
              <div className="text">
                <div className="heading mb-4  font-normal text-[14px] text-black">
                  <Text classes="uppercase">FOR PROFESSIONALS</Text>
                </div>
                <div className="desc xs:text-2xl md:text-3xl mb-4 ">
                  <Text>Establish Your Business's Hub on Gepzo</Text>
                </div>
                <div className="button flex">
                  <HoveredLink
                    className="shrink-0 inline-flex items-center bg-[#D66D5A] text-white rounded uppercase text-center h-10 px-6 transition-all duration-200 hover:text-[#D66D5A] hover:bg-white border-2 border-[#D66D5A] text-sm"
                    to={"/everyone"}
                  >
                    Get started
                  </HoveredLink>
                </div>
              </div>
            </div>
            <div className="img xs:w-4/12 md:w-6/12">
              <img
                src={prosImage}
                alt=""
                className="xs:h-[95%] lg:h-4/6 absolute top-1/2 -translate-y-1/2 xs:right-auto sm:right-0 md:-right-6"
              />
            </div>
          </div>
        </section>
      </main>
      <Footer />
    </>
  );
};

const HoveredLink = styled(Link)`
  &:hover {
    transform: translateY(-4px);
  }
`;

export default Intro;
